import * as React from 'react';
import { getComponentVariant } from '../theming/getComponentVariant.js';

/**
 * React hook that returns a modified theme to the calling component
 */
var useComponentVariant = function useComponentVariant(theme, variant) {
  var effectiveTheme = React.useMemo(function () {
    return getComponentVariant(theme, variant);
  }, [theme, variant]);
  return effectiveTheme;
};

export { useComponentVariant };
